module.exports = __webpack_public_path__ + "img/kanbanDescription.921a3e52.png";